// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2aZ9l","title":"card_title__39_1u","inActive":"card_inActive__29Hqn"};